<template>
  <Tabs ref="refTabs" v-bind="$attrs" :options="{ disableScrollBehavior: true }">
    <slot />
  </Tabs>
</template>

<script lang="ts" setup>
import { ref, onMounted, watch } from 'vue';
import { Tabs } from 'vue3-tabs-component';

const props = defineProps<{
  selectedTab?: string | null;
}>();
const refTabs = ref<typeof Tabs | null>(null);

onMounted(() => {
  if (props.selectedTab) {
    refTabs.value?.selectTab(props.selectedTab);
  }
});

watch(
  () => props.selectedTab,
  val => {
    if (val) {
      refTabs.value?.selectTab(val);
    }
  }
);
</script>
<style>
.tabs-component {
  @apply flex flex-col gap-8 md:gap-2;
}

.tabs-component-tabs {
  @apply pb-1 flex items-center gap-4 font-semibold overflow-x-auto hidden-scrollbar;
}

.tabs-component-tab-a {
  @apply block p-2 outline-none text-base focus-visible:ring ring-offset-4 rounded-md select-none focus-visible:ring-blue-500/50 dark:text-zinc-500 whitespace-nowrap;
}

.tabs-component-tab-a:hover:not(.is-active) {
  @apply bg-slate-100 dark:bg-zinc-700;
}

.tabs-component-tab-a.is-active {
  /* @apply text-blue-500 border-b-2 border-blue-500; */
  @apply text-blue-500 relative focus-visible:ring-0;
}

.tabs-component-tab-a.is-active::after {
  @apply content-[''] absolute top-full left-1/2 h-1 w-full rounded-full bg-blue-500 -translate-x-1/2;
}

.tabs-component-tab-a.is-active::after {
  animation: pulse 0.1s;
}

@keyframes pulse {
  0% {
    @apply w-0;
  }
  100% {
    @apply w-full;
  }
}
</style>
